__turbopack_context__.v({
  "responsive-image": "skeleton-module-scss-module__OHFBGq__responsive-image",
  "shimmer": "skeleton-module-scss-module__OHFBGq__shimmer",
  "skeleton": "skeleton-module-scss-module__OHFBGq__skeleton",
});
